module.exports = __webpack_public_path__ + "img/5.8825b654.png";